const Constants = Object.freeze({
  // ---------------------------- HOME ----------------------------
  TIME_ON: "Tiempo encendido: ",
  NUM_OF_DEVICES: "Número de dispositivos",
  MASTERS: "Maestros",
  SLAVES: "Esclavos",
  STATISTICS: "Estadísticas",

  NO_RETRIES: "Sin reintentos",

  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  CYCLE_TIME_S: "TIEMPO DE CICLO (s)",
  CYCLE_TIME_MS: "TIEMPO DE CICLO (ms)",

  WATCHDOG_MS: "WATCHDOG (ms)",

  RETRIES_LIMIT: "LÍMITE DE REINTENTOS",

  PROFIBUS_NETWORK_INFO: "Información de la red PROFIBUS",

  HSA_POPUP_1: "HSA (Highest PROFIBUS Address) es el parámetro que indica la dirección más alta en la que el maestro busca nuevos equipos en la red, utilizando el protocolo FDL_Status.",
  HSA_POPUP_2: "También se utiliza para la detección de maestros clase 2 o redes con más de un maestro.",

  // ---------------------------- Live List ----------------------------
  AVAILABILITY: "Disponibilidad",
  TAG: "Tag",
  ACTIVE: "Activo",
  INACTIVE: "Inactivo",
  REASON: "\nMotivo: ",

  EXPORT_CSV: "Exportar XLSX",
  CSV_HEADER: "Dirección,Tag,Modelo,Diagnósticos,Reintentos sin fallas,Reintentos totales,Fallas,Disponibilidad,Watchdog,Estado\n",

  // ---------------------------- Log ----------------------------
  TYPE: "Tipo",
  MANUFACTURER_MODEL: "Fabricante / Modelo",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocurrió un error al iniciar sesión: Nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Ocurrió un error al iniciar sesión:",

  GPG_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .gpg",
  SEND_FILE_FAILURE: "Ocurrió un error al enviar el archivo.",
  SEND_FILES_SUCCESS: "Los archivos fueron enviados con éxito.",
  SEND_FILE_WAITING: "Enviando archivo.",
  SEND_FILE_WRONG_FILENAME: "Nombre inválido. El archivo de actualización debe llamarse: updatePB.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se corrompió durante el envío.",
  SEND_CONFIG_SUCCESS: "Las configuraciones se enviaron con éxito.",
  SEND_CONFIG_FAILURE: "Ocurrió un error al enviar la configuración.",
  SEND_CONFIG_WAITING: "Enviando la configuración.",
  SEND_CONFIG_WAITING_2: "Finalizando el envío de la configuración.",
  SEND_CONFIG_DONE: "Configuración enviada.",
  SEND_NTP_CONFIG_WAITING: "Enviando la configuración del servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configuración del servidor NTP enviada.",

  WAITING: "Espere un momento",
  CLEAN_LOG_SUCCESS: "El log se limpió con éxito.",
  CLEAN_LOG_FAILURE: "Ocurrió un error al limpiar el log.",
  CLEAN_STATISTICS_SUCCESS: "Las estadísticas se limpiaron con éxito.",
  CLEAN_STATISTICS_FAILURE: "Ocurrió un error al limpiar las estadísticas.",

  CHANGE_USERNAME_SUCCESS: "El nombre de usuario fue cambiado con éxito. Por favor inicie sesión nuevamente.",
  CHANGE_USERNAME_FAILURE: "Ocurrió un error al cambiar el nombre de usuario: ",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña fue cambiada con éxito. Por favor inicie sesión nuevamente.",
  CHANGE_PASSWORD_FAILURE: "Ocurrió un error al cambiar la contraseña: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada es inválida",
  INVALID_SUBMASK: "\n- La máscara ingresada es inválida",
  INVALID_GATEWAY: "\n- La puerta de enlace ingresada es inválida",
  INVALID_DNS: "\n- El DNS ingresado es inválido",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no puede utilizarse como IP del monitor",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no puede utilizarse como IP del servidor NTP",
  SELECT_TIMEZONE: "\n- Es necesario seleccionar una zona horaria para configurar el servidor NTP",
  SAME_SUBNET_IP_1: "\n- La dirección IP de la interfaz WLAN no puede estar en la misma subred que la interfaz ETHERNET.",
  SAME_SUBNET_IP_2: "\n- La dirección IP de la interfaz ETHERNET no puede estar en la misma subred que la interfaz WLAN.",
  SUBNET_OVERLAP_WLAN: "\n- El TS Monitor PROFIBUS PRO detectó que existe superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la WLAN con la dirección IP y la máscara elegidas.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- El TS Monitor PROFIBUS PRO detectó que existe superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la interfaz ETHERNET con la dirección IP y la máscara elegidas.",
  ZERO_IP_MSG: "\n- La IP 0.0.0.0 no puede utilizarse como IP del TS Monitor PROFIBUS PRO",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no puede utilizarse como máscara de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast de la red no puede utilizarse como IP del TS Monitor PROFIBUS PRO",
  NETWORK_IP_MSG: "\n- La IP de la red no puede utilizarse como IP del TS Monitor PROFIBUS PRO",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast de la red no puede utilizarse como IP del gateway",
  NETWORK_GATEWAY_MSG: "\n- La IP de la red no puede utilizarse como IP del gateway",

  EMPTY_WIFI_PWD: "\n- La contraseña Wi-Fi no puede estar vacía",

  ALTER_USERNAME: "CAMBIAR USUARIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  RESTART_SYSTEM: " Reiniciar sistema",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Ocurrió un error al intentar reiniciar el sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada con éxito. Espere aproximadamente 3 minutos para que el sistema se reinicie completamente.",

  SELECT_FILE: "Por favor seleccione un archivo para enviar",
  SELECT_GSD_FLIE: "Por favor seleccione al menos un archivo GSD para enviar",
  SENDING_GSD_FILES: "Enviando archivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para seguir la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos en el monitor. Por favor espere.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados, preparándose para reiniciar el monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando el monitor, espere algunos minutos.",
  UPDATE_SUCCESS: "¡La actualización se realizó con éxito!",
  UPDATE_ERROR_STRING: "Ocurrió el siguiente error al actualizar el monitor: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar la configuración de la interfaz.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar la configuración WLAN.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "La tag del monitor fue modificada con éxito.",
  TAG_CHANGE_FAILURE: "Ocurrió un error al modificar la tag del monitor.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerde actualizar la dirección del navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz se actualizó con éxito!",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡La configuración WLAN se actualizó con éxito!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocurrió un error al enviar los siguientes archivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocurrió un error al eliminar los siguientes archivos GSD: ",

  MANAGE: "Gestionar",

  TAG_CONFIG: "Tag de la red",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisión y acceso web a los datos del monitor.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando el adaptador está disponible.",
  WLAN_POPUP_2: "Utilizado para supervisión y acceso web a los datos del monitor.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea encender el servidor NTP? Para ello el monitor deberá reiniciarse.",

  NTP_INFO_TURNED_ON_FAILURE: "Ocurrió un error al encender el servidor NTP.",

  PROCESSING_NTP_INIT: "Iniciando el procesamiento de la información del servidor NTP",
  PROCESSING_NTP_INFO: "Procesando la información del servidor NTP.",
  PROCESSED_NTP_INFO: "Información del servidor NTP procesada.",
  PROCESSING_NTP_ERROR: "Ocurrió un error al enviar la información al servidor NTP. Verifique si la dirección IP del servidor es correcta. Si lo es, verifique también si el servicio NTP está encendido e inténtelo nuevamente.",

  MONITOR_RESTART_SUCCESS: "El monitor se reinició con éxito.",
  MONITOR_RESTART_FAILURE: "Ocurrió un error al reiniciar el monitor.",

  NTP_INFO_TURNED_OFF_FAILURE: "Ocurrió un error al apagar el servidor NTP.",
  NTP_INFO_FAILURE: "Error al sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",

  SEND_WLAN_CONFIG_WAITING: "Enviando la configuración, por favor espere. Esto puede tardar alrededor de un minuto.",
  UPDATE_WLAN_CONFIG_ERROR: "No fue posible conectarse a la red WLAN. Si el problema persiste, intente reiniciar el monitor o el router WLAN.",

  ALTER_MONITOR_CONFIG: "¿Está seguro de que desea cambiar la configuración del monitor?",
  IP: "IP",
  EDIT: "Editar",
  CLEAR: "Limpiar",
  ALTER: "Cambiar",
  REPORT: "Informe",
  ALTER_LOGIN: "Cambiar login",
  SEND: "Enviar",
  GSD_FILES: "Archivos GSD",
  SOFTWARE_UPDATE: "Actualización de software",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",

  USER: "Usuario",
  NEW_PASSWORD: "Nueva contraseña",
  REPEAT_PASSWORD: "Repetir contraseña",
  LOGOUT: "Logout",
  TEST_NETWORK: "Red de prueba",
  TIMEZONE: "Zona horaria",
  DHCP: "DHCP",
  FIXED_IP: "IP Fija",

  INTERFACE_CONFIG: "Configuración de interfaz",
  LOGIN: "LOGIN",

  ENTER: "Entrar",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "El TS Expert detectó una posible falla en el nivel de tensión (Acción requerida).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "El TS Expert detectó una posible falla en el nivel de tensión (Acción urgente).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "El TS Expert detectó una posible falla por relé.",
  EVENT_CHECKED_SUCCESS: "El evento se limpió con éxito.",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuración WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Intensidad de señal",
  FREQUENCY: "Frecuencia",
  CHANNEL: "Canal",
  QUALITY: "Calidad",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidad",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN, por favor espere.",
  TURNING_WLAN_ON_WAITING: "Encendiendo el adaptador WLAN, por favor espere.",

  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Máscara",
  GATEWAY: "Puerta de enlace",
  PASSWORD: "Contraseña",

  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar la configuración WLAN del monitor?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN del monitor.",
  WLAN_STATUS_POPUP_2: "Si está apagado no es posible cambiar la configuración WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica si el monitor está conectado o no a la red WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "No es posible cambiar la configuración mientras el adaptador WLAN esté apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda encarecidamente cambiar la configuración WLAN solo al acceder al monitor por medio de la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / máscara, si los campos aparecen en blanco después de la actualización, esto es un fuerte indicio de que:",
  WLAN_CONFIG_POPUP_4: "Ya existe otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La máscara de red es demasiado restrictiva y no admite la IP proporcionada.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor PROFIBUS no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique si el adaptador está desconectado o tiene mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado ni tiene mal contacto, intente reemplazarlo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores soluciona el problema, póngase en contacto con Toledo e Souza.",

  LOADING_WAITING: "Cargando información, por favor espere.",
  WLAN_INFO: "Información WLAN",
  MAC: "MAC",
  DNS: "DNS",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "¿Está seguro de que desea cambiar el hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para ello es necesario reiniciar el monitor.",
  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar únicamente con letras y números.",
  INVALID_HOSTNAME_1: "El hostname debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El hostname debe contener solo letras, números, puntos y guiones, y debe comenzar y terminar únicamente con letras y números.",
  HOSTNAME_CONFIG_SUCCESS: "El hostname fue configurado con éxito.",
  HOSTNAME_CONFIG_ERROR: "Ocurrió un error al configurar el hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID oculto",
  OPTIONAL: " (Opcional)",

  HOSTNAME: "Hostname",

  // ---------------------------- Edit Tags page related ----------------------------
  TAGS: "Tags",
  ADD_ALTER_TAGS: "Agregar/Cambiar Tags",
  CHOOSE_DEVICE: "Elija un dispositivo",
  NEW_TAG: "Nueva TAG",
  SAVE: "Guardar",
  REMOVE_ALL_TAGS: "Eliminar todas las Tags",
  REMOVE: "Eliminar",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar las tags de todos los dispositivos?",
  CHANGE_TAG_SUCCESS: "La tag fue cambiada con éxito.",
  CHANGE_TAG_FAILURE: "Ocurrió un error al cambiar la tag",
  REMOVE_TAG_SUCCESS: "Las tags fueron eliminadas con éxito.",
  REMOVE_TAG_FAILURE: "Ocurrió un error al eliminar las tags",
  IMPORT_TAGS_SUCCESS: "Las tags fueron importadas con éxito",
  IMPORT_TAGS_FAILURE: "Ocurrió un error al importar las tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor seleccione un archivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  // ---------------------------- Edit GSD page related ----------------------------
  REMOVE_GSD_SUCCESS: "Los archivos GSD fueron eliminados con éxito",
  REMOVE_GSD_FILES: "Gestionar archivos GSD",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor seleccione al menos un archivo para eliminar",
  REMOVING_GSD_FILES: "Eliminando archivos GSD",
  FILTER_GSD_FILES: "Filtrar archivos GSD",
  SELECT_ALL: "Seleccionar todos",
  REMOVER_SELECIONADOS: "Eliminar seleccionados",

  // ---------------------------- Blacklist page related ----------------------------
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Ocurrió un error al agregar esclavos a la blacklist.",

  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Ocurrió un error al eliminar esclavos de la blacklist.",

  REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE: "Ocurrió un error al eliminar esclavos de la lista de esclavos críticos.",

  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por dirección, tag o modelo",
  BLACKLIST_ADDRESS: "Dirección",
  BLACKLIST_TAG: "Tag",
  BLACKLIST_MODEL: "Modelo",
  BLACKLIST_CRITICAL_SLAVE: "Esclavo crítico",
  UPDATE_BLACKLIST: "Actualizar blacklist",
  UPDATING_BLACKLIST_DATA: "Actualizando información, espere",

  BLACKLIST_HEADER_CELL_POPUP: "Impide el registro de logs de determinado equipo para no generar eventos repetitivos o no deseados.",
  BLACKLIST_HEADER_CELL_POPUP_2: "El esclavo en blacklist no altera el estado de la red en la pestaña Resumen. Sus fallas, reintentos y diagnósticos son contabilizados.",

  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP: "Los esclavos que presentan altas cantidades de eventos se insertan automáticamente en la lista de esclavos críticos. Sus eventos dejan de guardarse para no saturar el log, pero sus fallas, reintentos y diagnósticos son contabilizados.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2: "El usuario puede eliminar esclavos críticos, pero no agregarlos.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3: "Si existe al menos un esclavo crítico en la lista, altera el estado de la red a ESCLAVO CRÍTICO en la pestaña Resumen.",

  CONFIRM_ALTER_BLACKLIST: "¿Está seguro de que desea realizar cambios en la blacklist y en la lista de esclavos críticos?",

  // ---------------------------- PDF Report ----------------------------
  REPORT_TYPE: "Tipo de Informe",

  PROJECT_NAME_LABEL: "Nombre del proyecto",
  NETWORK_LABEL: "Nombre de la red",
  LOCATION_LABEL: "Ubicación",
  COMPANY_NAME_LABEL: "Nombre de la empresa",
  ACCOUNTABLE_NAME_LABEL: "Nombre del responsable",
  CITY_LABEL: "Ciudad",
  TEL_LABEL: "Teléfono",
  CLIENT_LOGO_LABEL: "Logo del cliente",
  EMAIL_LABEL: "Correo electrónico",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo de la empresa ejecutora",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Guardar informe",

  PROFIBUS: "PROFIBUS",

  REPORT_EXPORT_NAME: "Informe TS Monitor PROFIBUS",
  HEADER_TEXT: "Informe de datos - TS Monitor PROFIBUS",

  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",
  GENERATING_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en guardar informe abajo.",

  CONFORMITY: "Conformidad",
  DROPDOWN_PLACEHOLDER: "Elija una opción",
  GENERATE_REPORT: "Generar informe",

  GENERAL_REPORT: "Informe general – TS Monitor PROFIBUS",
  DATA_REPORT: "Informe de datos – TS Monitor PROFIBUS",

  MONITORING_INFO: "Información del monitoreo",
  ETHERNET_INFO: "Información ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Puerta de enlace: ",

  CLIENT_INFO: "Información del cliente",
  EXECUTING_COMPANY_INFO: "Información de la empresa ejecutora",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme con restricciones",
  NON_CONFORM_STRING: "No conforme",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Ubicación:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- Email:",

  NETWORK_NAME_DP: "- Nombre de la red: ",
  TAG_NAME_DP: "- Tag de la red: ",
  MONITOR_VERSION_DP: "- Versión del monitor: ",
  MONITOR_INIT_DP: "- Inicio del monitoreo: ",
  GENERATING_TIME_DP: "- Generación del informe: ",
  DURATION_SINCE_MON_BEGIN: "- Duración del monitoreo hasta la generación del informe: ",

  TS_MONITOR_VER_DP: "TS Monitor PROFIBUS - Versión ",
  NETWORK_AVAILABILITY_DP: "Disponibilidad de la red: ",
  BAUD_RATE_DP: "Baud rate: ",
  CYCLE_TIME_DP: "Tiempo de ciclo: ",
  DEVICE_DATA: "Datos de los dispositivos",
  MASTERS_DP: "Maestros: ",
  SLAVES_DP: "Esclavos: ",
  ONLINE_SLAVES_DP: "Esclavos online: ",
  MISSING_DP: "Ausentes: ",
  RETRIES_DP: "Reintentos: ",
  DIAGNOSTIC_DP: "Diagnósticos: ",
  FAULT_DP: "Fallas: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Límite de reintentos: ",
  HSA_DP: "HSA: ",

  SUMMARY: "Sumario",
  RESUME: "Resumen",
  LIVE_LIST: "Live List",
  LOG: "Log",
  MATRIX: "Matriz",
  GRAPHIC_TOPOLOGY: "Topología gráfica",
  CONFIG_STRING: "Configuraciones",

  RESUME_DOTS: ".....................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "...................................................................................................................................",

  M_MONITORING_RESUME_PAGE_TITLE: "1. - Resumen",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live List",
  M_MONITORING_LOG_PAGE_TITLE: "3. - Log",

  OPTIC_FIBER_PAGE_TITLE: "1. - Fibra Óptica",
  OPTIC_FIBER_LOG_PAGE_TITLE: "2. - Log",
  OPTIC_FIBER_DOTS: "...................................................................................................................................",
  OPTIC_FIBER_1_DOTS: "................................................................................................................",
  MONITORING_DOTS: ".................................................................................................................",

  SELECT_REPORT_TYPE: "Por favor seleccione un tipo de informe",

  ADDRESS: "Dirección",
  MODEL: "Modelo",

  LAST_200_EVENTS: "Últimos 200 eventos",
  HORARY: "Horario",
  DESCRIPTION: "Descripción",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Los datos y valores presentados en este informe son meramente auxiliares para el especialista en PROFIBUS, de tal manera que cualquier indicación de corrección debe ser hecha por el usuario. Por esta razón, se recomienda el acompañamiento de un ingeniero certificado en PROFIBUS o del técnico responsable del análisis para avalar la información proporcionada por el producto. Por lo tanto, Toledo & Souza se exime de cualquier responsabilidad, pérdida o daño, directo o indirecto, causado por las interpretaciones del software, no ofreciendo ninguna garantía en relación con la integridad, calidad o adecuación de la información proporcionada, ya que dependen del análisis técnico de un profesional capacitado, y en ausencia de este, el usuario asumirá el riesgo de que el contenido pueda ser impreciso, incompleto o no satisfacer sus necesidades y requisitos.",

  DIAGNOSTIC_STRING: "Diagnóstico",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Ausentes",
  MISSING_SINGULAR_STRING: "Ausente",
  CONFIG_ERROR_STRING: "Error de configuración",
  PARAM_ERROR_STRING: "Error de parametrización",
  FAULT_STRING: "Falla",
  BLACKLIST_STRING: "Blacklist",
  CRITIC_SLAVE_STRING: "Esclavo crítico",
  MASTER_FAULT_STRING: "Maestro",
  SLAVE_MASTER_FAULT_STRING: "Maestro en falla",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI en falla",
  MASTER_CLASS_2: "Maestro",
  MASTER_OPERATE: "Maestro - operate",
  MASTER_SYNC: "Maestro - sync",
  MASTER_UNSYNC: "Maestro - unsync",
  MASTER_FREEZE: "Maestro - freeze",
  MASTER_UNFREEZE: "Maestro - unfreeze",
  MASTER_CLEAR: "Maestro - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Maestro - Operate",
  MASTER_SYNC_CAPITAL: "Maestro - Sync",
  MASTER_UNSYNC_CAPITAL: "Maestro - Unsync",
  MASTER_FREEZE_CAPITAL: "Maestro - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Maestro - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Maestro - Clear",

  PAGE: "Página",

  YEAR: " año",
  MONTH: " mes",
  MONTHS: " meses",
  DAY: " día",
  HOUR: " hora",
  MINUTE: " minuto",
  SECOND: " segundo",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior a la última inicialización",
  REMOVE_DEVICE_SUCCESS: "El dispositivo será eliminado en hasta 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocurrió un error al eliminar el dispositivo: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "La red tiene esclavos en diagnóstico",
  WITH_FAILURE_STRING: "La red tiene esclavos en falla",
  WITH_CRITICAL_SLAVE_STRING: "La red tiene esclavos en estado crítico",
  WITH_MASTER_FAULT_STRING: "La red tiene maestros en falla",
  UNKNOWN: "Desconocido",
  LOG_WAITING: "Cargando datos del log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o estado",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección, tag, modelo o \"Evento de la red\"",
  OPTIC_FIBER_LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por tipo de evento",
  OPTIC_FIBER_INSERT_VALID_TYPE: "Por favor, escriba un tipo de evento válido.",
  SLAVE_DIAGNOSTIC: "Diagnóstico del esclavo:",
  STATUS_CHANGE: "Cambio de estado: ",
  NETWORK_EVENT: "Evento de la red",
  MASTER_HASHTAG: "Maestro #",
  SLAVE_HASHTAG: "Esclavo #",
  CONFIG_ERROR_1: "Error de ",
  CONFIG_ERROR_2: "configuración",
  PARAM_ERROR_1: "Error de ",
  PARAM_ERROR_2: "parametrización",
  LAST_EVENT: "Último evento: ",

  DIAGNOSTICS_STRING: "Diagnósticos",
  RETRIES_STRING: "Reintentos",
  NO_FAULTS_STRING: "sin fallas",
  TOTAL: "totales",
  RETRIES_NO_FAULT_STRING: "Reintentos sin fallas",
  FAULTS_STRING: "Fallas",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Mil millones de",
  BILLIONS_OF: "Mil millones de",
  MILLION_OF: "Millón de",
  MILLIONS_OF: "Millones de",
  THOUSAND: "Mil",
  LAST_EVENT_TOO_BIG_STRING: "Descripción muy larga, por favor consulte el log.",
  CRITICAL_SLAVE_EXPLANATION: "TS Monitor posee una función automática para seleccionar los esclavos que tengan un número excesivo de eventos e informar al usuario que este dispositivo es crítico para la red PROFIBUS.",
  DIAGNOSTICS_QUESTION_INFO: " Indica el número de diagnósticos detectados en la red PROFIBUS. Los diagnósticos indican condiciones anormales del estado del dispositivo, como cortocircuito, problema de alimentación, falta de módulo, etc.",
  RETRIES_QUESTION_INFO: "Indica el número de veces que el maestro necesitó reenviar un mensaje a determinado equipo después de no recibir respuesta. Indica, usualmente, problemas en la capa física.",
  FAULTS_QUESTION_INFO: "Indica el número de veces que determinado equipo PROFIBUS dejó de responder a los mensajes del maestro.",
  NOT_RETRIES_QUESTION_INFO: "El reintento sin falla nos ayuda a verificar problemas de red que aún no causaron la caída del dispositivo. También desconsidera las caídas que ocurrieron por apagado o desconexión.",

  WATCHDOG_QUESTION_INFO_1: "El watchdog es el tiempo que el esclavo espera después de perder la comunicación con el maestro hasta modificar sus salidas a la condición segura.",
  WATCHDOG_QUESTION_INFO_2: "Este parámetro es enviado por el maestro a todos los esclavos de la red, individualmente, en su respectivo telegrama de parametrización.",
  WATCHDOG_QUESTION_INFO_3: "Si el tiempo de ciclo está próximo al watchdog, la red queda más vulnerable.",
  WATCHDOG_QUESTION_INFO: "Indica si el watchdog para el dispositivo está activo, inactivo o aún no ha sido parametrizado.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Buscar dispositivo por dirección o tag",

  EDIT_TOPOLOGY_POS_STRING: "Editar",
  EDIT_EDGE_TYPE: "Editar tipo de conexión",
  SAVE_TOPOLOGY_POS_STRING: "Guardar",
  DELETE_TOPOLOGY_POS_STRING: "Eliminar",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topología",
  IMPORT: "Importar",
  IMPORT_TOPOLOGY: "Importar Topología",
  POSITION: "Posición",
  EXPORT: "Exportar",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "¡La posición de la topología se guardó con éxito!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocurrió el siguiente error al guardar la posición de la topología: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "¡La posición de la topología se eliminó con éxito!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocurrió el siguiente error al eliminar la posición de la topología: ",

  ASK_REMOVE_POSITIONING: "¿Está seguro de que desea eliminar la posición guardada?",
  REMOVE_POSITIONING: "Eliminar posición",

  YES: "Sí",
  NO: "No",

  ALERT_NOT_POSSIBLE_TO_EDIT: "No es posible editar datos del maestro",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "No es posible editar los datos de TS Scope",
  ALERT_NOT_POSSIBLE_TO_DELETE: "No es posible eliminar un dispositivo de la live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor elija un tipo de dispositivo",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor seleccione un tipo de conexión",

  ADD_DEVICE: "Agregar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de dispositivo",
  ADD_CONNECTION: "Agregar conexión",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de conexión",
  EDIT_DEVICE: "Editar dispositivo",

  CANCEL: "Cancelar",
  ADD: "Agregar",

  MASTER_NAME: "Maestro",
  SLAVE_NAME: "Esclavo",
  SLAVE_PA_NAME: "Esclavo PA",
  REPEATER_NAME: "Repetidor",
  HUB_NAME: "Hub",
  JB_NAME: "Caja de conexiones",
  COUPLER_PROXY_NAME: "Acoplador/Proxy",
  FIBER_LINK_NAME: "Enlace de fibra",
  ACTIVE_TERMINATION_NAME: "Terminador activo",
  UNKNOWN_NAME: "Desconocido",
  TS_MONITOR_NAME: "TS Monitor",
  MPI_NAME: "MPI",
  TS_SCOPE_DP_NAME: "TS Scope DP",
  TS_SCOPE_PA_NAME: "TS Scope PA",

  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Eliminar seleccionado",
  LOCALE_BACK: "Volver",
  LOCALE_ADD_NODE: "Agregar dispositivo",
  LOCALE_ADD_EDGE: "Agregar conexión",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexión",
  LOCALE_ADD_DESCRIPTION: "Haga clic en un espacio en blanco para agregar un nuevo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Haga clic en un dispositivo y arrastre la conexión hasta otro dispositivo para conectarlos",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Haga clic en los puntos de control y arrástrelos hasta un dispositivo para conectarlos",
  LOCALE_CREATE_EDGE_ERROR: "No es posible crear una conexión para un clúster",
  LOCALE_DELETE_CLUSTER_ERROR: "Los clústeres no pueden eliminarse",
  LOCALE_EDIT_CLUSTER_ERROR: "Los clústeres no pueden editarse",

  FORM_NO_DEVICE_FOUND_PREFIX: "El dispositivo con dirección ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " no fue encontrado",

  INSERT_VALID_ADDRESS_OR_TAG: "Por favor ingrese una dirección o tag válidas",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Por favor ingrese una dirección, tag o modelo válidos",

  POSITIONING_CONFLICT_1: "Existe un conflicto en la información de los dispositivos con direcciones:",
  POSITIONING_CONFLICT_2: "\nDebido a ello, sus posiciones y conexiones volverán al estado predeterminado.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Las posiciones y conexiones volvieron al estado predeterminado con éxito",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocurrió el siguiente error al devolver las posiciones y conexiones al estado predeterminado: ",

  TOPOLOGY_IMPORT_SUCCESS: "¡La topología fue importada con éxito!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocurrió un error al importar la topología gráfica: ",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está corrupto.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor seleccione un archivo de topología.",

  COLORS_LABELS: "Leyenda de colores",
  LABEL_SLAVE_OK_MASTER_OP: ": Esclavo ok, y maestro en operate;",
  LABEL_MASTER_STOP_CLEAR: ": Maestro en STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Esclavo en diagnóstico;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Esclavo en falla, y maestro en falla;",
  LABEL_SLAVE_CONFIG_ERROR: ": Esclavo con error de configuración;",
  LABEL_SLAVE_PARAM_ERROR: ": Esclavo con error de parametrización;",
  LABEL_SLAVE_ONLINE: ": Esclavo online;",
  LABEL_SLAVE_MISSING: ": Esclavo ausente;",
  LABEL_SLAVE_MASTER_FAULT: ": Esclavo con maestro en falla;",
  LABEL_SLAVE_BLACKLIST: ": Esclavo en blacklist;",
  LABEL_CRITICAL_SLAVE: ": Esclavo crítico;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Dispositivo sin estado.",

  DEVICE_TAG_NOT_FOUND: "No se encontró ningún dispositivo con la TAG: ",

  INSERT_VALID_ADDRESS_1_127: "Ingrese una dirección de esclavo válida, entre 1 y 127.",
  DEVICE_WITH_ADDRESS: "El dispositivo con dirección ",
  WAS_SUCCESSFULLY_ADDED: " fue agregado con éxito.",
  WAS_SUCCESSFULLY_REMOVED: " fue eliminado con éxito.",
  IS_ALREADY_IN_NETWORK: " ya está en la red.",
  REMOVE_DEVICE_ERROR: "Ocurrió el siguiente error al intentar eliminar el dispositivo: ",

  TS_SCOPE_NOT_FOUND: "No fue posible encontrar el TS Scope de IP:",
  INVALID_INSERTED_IP: "La IP ingresada es inválida",
  TS_SCOPE_FETCH_SUCCESS: "La obtención del TS Scope fue exitosa",

  AN_ERROR_OCURRED: "Ocurrió un error",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  TS_EXPERT: "TS Expert",
  SETUP: "Configurar",

  TS_EXPERT_CONFIGURATION: "Configuración de TS Expert",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando la configuración de TS Expert, espere un momento.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "La configuración de TS Expert se guardó con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocurrió un error al guardar la configuración de TS Expert.",

  CONFIG_RETRIES_LIST_HEADER: "Reintentos sin falla",
  CONFIG_RETRIES_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará los reintentos que no llevaron a una falla, por dispositivo. El reintento sin falla nos ayuda a verificar problemas de red que aún no causaron la caída del dispositivo. También desconsidera las caídas que ocurrieron por apagado o desconexión.",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnósticos",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los diagnósticos, por dispositivo.",

  CONFIG_FAULT_LIST_HEADER: "Fallas",
  CONFIG_FAULT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todas las fallas, por dispositivo.",

  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Secuencia de fallas",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las fallas que ocurrieron en secuencia en caso de fallas de varios dispositivos.",

  CONFIG_CONFIG_ERROR_LIST_HEADER: "Error de configuración",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los dispositivos que presentan error de configuración.",

  CONFIG_PARAM_ERROR_LIST_HEADER: "Error de parametrización",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los dispositivos que presentan error de parametrización.",

  CONFIG_MISSING_LIST_HEADER: "Esclavo ausente",
  CONFIG_MISSING_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los esclavos ausentes.",

  CONFIG_ONLINE_LIST_HEADER: "Esclavo online",
  CONFIG_ONLINE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los esclavos online.",

  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Esclavo crítico",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todos los esclavos críticos.",

  CONFIG_MASTER_FAULT_LIST_HEADER: "Maestro en falla",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará cuando TS Monitor no esté recibiendo tramas PROFIBUS.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Link de fibra óptica – Falla en el nivel de tensión (Acción requerida)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará baja tensión en las salidas analógicas que indican la calidad de la señal recibida por el link de fibra. Este valor puede ser configurado por el usuario en la pantalla de configuración de su TS Scope/Monitor PRO.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Link de fibra óptica – Falla en el nivel de tensión (Acción urgente)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará baja tensión en las salidas analógicas que indican la calidad de la señal recibida por el link de fibra. Este valor puede ser configurado por el usuario en la pantalla de configuración de su TS Scope/Monitor PRO.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Link de fibra óptica – Falla por relé",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert mostrará falla en el link de fibra indicada por relé, que debe estar conectado al TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de acciones - TS Expert - PROFIBUS",

  TS_EXPERT_POPUP_1: "En esta pestaña se presenta la información de TS Expert.",
  TS_EXPERT_POPUP_2: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Monitor en redes PROFIBUS.",
  TS_EXPERT_POPUP_3: "De forma automatizada, mantenimiento, ingeniería y equipos relacionados pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los cuales fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no excluye la necesidad del análisis humano ni reemplaza la capacidad humana de correlacionar e interpretar datos.",

  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor verifique su red.",

  EXPORT_ACTIONS_LIST: "Exportar lista de acciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de la lista de acciones, por favor espere.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en guardar lista de acciones.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Acciones",

  NO_PROBLEM_DETECTED: "TS Expert no detectó ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No existen eventos para analizar.",

  NO_EVENT_SELECTED: "Ningún evento seleccionado",
  CHOOSE_AN_EVENT: "Elija un evento para visualizar las acciones sugeridas.",

  DETAILING: "Detalle",

  CHECKED: "Verificado",
  BATCH_CHECK: "Verificar todos",

  PROBLEM_CHECKED: "El evento fue verificado con éxito",
  PROBLEM_CHECK_ERROR: "Ocurrió un error al verificar el evento.",

  LAST_UPDATED: "Actualizado por última vez en: ",
  THIS_COMPUTER_TIME: " (Hora de este ordenador)",

  DEVICE: "Dispositivo",

  ALL_EVENTS_CHECKED: "Todos los eventos fueron verificados con éxito.",
  _ADDRESS: "• Dirección: ",
  ACTIONS_LIST_EXPORT_NAME: "Lista de acciones - TS Expert - PROFIBUS.pdf",
  SAVE_ACTIONS_LIST: "Guardar lista de acciones",

  // ---------------------------- RETRIES (TS EXPERT) ----------------------------
  RETRIES_LIST_HEADER: "Existen dispositivos en la red que poseen reintentos sin fallas.",
  DEVICE_WITH_RETRIES: "Dispositivo con reintentos sin fallas.",

  RETRIES_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía poseen reintentos:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía posee reintentos\n",

  RETRIES_SUGGESTION_1: "Cuando un dispositivo posea reintentos sin fallas se sugiere:",
  RETRIES_SUGGESTION_2: "Los reintentos sin fallas indican el número de veces que el maestro necesitó reenviar un mensaje a determinado equipo después de no recibir respuesta, ya sea porque el esclavo no respondió o porque la respuesta estaba corrompida (trama ilegal o incompleta), por efecto de ruido, bajo aislamiento en el esclavo o en la infraestructura del bus. El reintento sin falla nos ayuda a verificar problemas de red que aún no causaron la caída del dispositivo. También desconsidera las caídas que ocurrieron por apagado o desconexión.",
  RETRIES_SUGGESTION_3: "Verificar y corregir el montaje del conector. El TDC-1000 puede ayudar en esta tarea;",
  RETRIES_SUGGESTION_4: "Verificar daños en el cable PROFIBUS, como:",
  RETRIES_SUGGESTION_5: "Doblez menores que 10 veces el radio del conductor;",
  RETRIES_SUGGESTION_6: "Cortes en el cable;",
  RETRIES_SUGGESTION_7: "Torsiones en el cable;",
  RETRIES_SUGGESTION_8: "Aplastamientos en el cable.",
  RETRIES_SUGGESTION_9: "Estas no conformidades exigen el cambio del tramo de cable (no es posible solucionar la no conformidad desdoblando o desamoldando el cable);",
  RETRIES_SUGGESTION_10: "Verifique si hay cables de potencia próximos a cables PROFIBUS. Los cables de datos como PROFIBUS deben estar separados lo más posible o en bandejas/conductos cerrados y aterrizados, siguiendo el mínimo indicado por las directrices de acuerdo con la clasificación del conductor eléctrico, norma EN50174;",
  RETRIES_SUGGESTION_11: "Medir la corriente de fuga en el cable con una pinza adecuada; si la medida es mayor que 100mA, es necesario revisar la equipotencialización y el sistema de puesta a tierra;",
  RETRIES_SUGGESTION_12: "Verificar la calidad de la señal con uno de los equipos de Toledo e Souza que posea osciloscopio, que le dará sugerencias según las mediciones realizadas;",
  RETRIES_SUGGESTION_13: "Si ninguno de los puntos anteriores resuelve el problema, y un determinado equipo está presentando reintentos de forma aislada (solo un determinado esclavo presenta reintentos), se sugiere sustituir la interfaz de red del esclavo.",
  RETRIES_SUGGESTION_14: "El único punto que puede tener mejor resultado con la planta en funcionamiento es el punto “d”; sin embargo, el uso del equipo de Toledo e Souza que posee osciloscopio debe realizarse con cautela, pues si la condición de la señal está muy comprometida puede derribar la red.",

  // ---------------------------- DIAGNOSTIC (TS EXPERT) ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Existen dispositivos en la red que poseen diagnósticos.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo con diagnósticos",

  DIAGNOSTIC_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía poseen diagnósticos:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía posee diagnósticos\n",

  DIAGNOSTIC_SUGGESTION_1: "Cuando un dispositivo posea diagnósticos se sugiere:",
  DIAGNOSTIC_SUGGESTION_2: "El estado “Diagnóstico” es una información enviada por el esclavo al maestro; por lo general no es un problema de red, sino un aviso del esclavo de que necesita mantenimiento o sustitución. A continuación se presenta la lista de acciones para resolver el problema:",
  DIAGNOSTIC_SUGGESTION_3: "Si un esclavo presenta diagnóstico, verifique la información enviada e intente solucionar el problema; si tiene dificultad para entender el diagnóstico, póngase en contacto con el fabricante del esclavo para resolver sus dudas antes de una intervención;",
  DIAGNOSTIC_SUGGESTION_4: "El número creciente de diagnósticos sin datos de mantenimiento puede estar directamente ligado a las fallas del dispositivo, pues cuando el equipo vuelve a comunicar existe un diagnóstico de verificación que comprueba si el esclavo está listo para el intercambio de datos. Verifique si el número de diagnósticos está próximo al de fallas; en ese caso siga el paso a paso de pruebas para fallas.",

  // ---------------------------- FAULT (TS EXPERT) ----------------------------
  FAULT_LIST_HEADER: "Existen dispositivos en la red que poseen fallas.",
  DEVICE_WITH_FAULT: "Dispositivo con fallas",

  FAULT_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía poseen fallas:\n",
  S_FAULT_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía posee fallas\n",

  FAULT_SUGGESTION_1: "Cuando un dispositivo posea fallas se sugiere:",
  FAULT_SUGGESTION_2: "El estado “Falla” indica que el esclavo dejó de comunicar, es decir, dejó de intercambiar datos con el maestro (cayó de la red). En este caso no es posible determinar el motivo de la falla, que puede ser, por ejemplo, una rotura de cable o falta de alimentación eléctrica:",
  FAULT_SUGGESTION_3: "Verificar la alimentación del esclavo;",
  FAULT_SUGGESTION_4: "Verificar si está conectado a la red (cable o fibra óptica);",
  FAULT_SUGGESTION_5: "Verificar la integridad y el correcto montaje del conector;",
  FAULT_SUGGESTION_6: "Verificar la integridad del cable;",

  // ---------------------------- FAULT SEQUENCE (TS EXPERT) ----------------------------
  FAULT_SEQ_LIST_HEADER: "Existen dispositivos en la red que poseen secuencias de fallas.",
  DEVICE_WITH_FAULT_SEQ: "Dispositivo con secuencia de fallas",

  FAULT_SEQ_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía poseen secuencia de errores:\n",
  S_FAULT_SEQ_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía posee secuencia de errores\n",

  FAULTS_SEQ_SUGGESTION_1: "En caso de una secuencia de fallas de dispositivos se sugiere:",
  FAULTS_SEQ_SUGGESTION_2: "Verificar la alimentación de los esclavos que dejaron de comunicar;",
  FAULTS_SEQ_SUGGESTION_3: "Verificar la calidad de la señal en el segmento del primer esclavo que dejó de comunicar con uno de los equipos de Toledo e Souza que posea osciloscopio;",
  FAULTS_SEQ_SUGGESTION_4: "Verificar si están conectados a la red;",
  FAULTS_SEQ_SUGGESTION_5: "Verificar si algún terminador aislador fue encendido accidentalmente;",
  FAULTS_SEQ_SUGGESTION_6: "Verificar los terminadores de red de este segmento;",
  FAULTS_SEQ_SUGGESTION_7: "Verificar la integridad del bus de este segmento;",
  FAULTS_SEQ_SUGGESTION_8: "Verificar fallas potenciales en repetidores, hubs o enlaces de fibra óptica.",

  // ---------------------------- CONFIG ERROR (TS EXPERT) ----------------------------
  CONFIG_ERROR_LIST_HEADER: "Existen dispositivos en la red con error de configuración.",
  DEVICE_WITH_CONFIG_ERROR: "Dispositivo con error de configuración",

  CONFIG_ERROR_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía presentan error de configuración:\n",
  S_CONFIG_ERROR_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía presenta error de configuración\n",

  CONFIG_ERROR_SUGGESTION_1: "Cuando un dispositivo posea error de configuración se sugiere:",
  CONFIG_ERROR_SUGGESTION_2: "Esto ocurre cuando algún esclavo no aceptó la configuración realizada en el maestro o SDCD y no entró en intercambio de datos. Sugerencia:",
  CONFIG_ERROR_SUGGESTION_3: "Verifique la configuración en el software del maestro o SDCD;",

  // ---------------------------- PARAM ERROR (TS EXPERT) ----------------------------
  PARAM_ERROR_LIST_HEADER: "Existen dispositivos en la red con error de parametrización.",
  DEVICE_WITH_PARAM_ERROR: "Dispositivo con error de parametrización",

  PARAM_ERROR_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía presentan error de parametrización:\n",
  S_PARAM_ERROR_INITIAL_ERROR_MSG: "No fue posible verificar el evento del siguiente dispositivo, pues todavía presenta error de parametrización\n",

  PARAM_ERROR_SUGGESTION_1: "Cuando un dispositivo presente error de parametrización se sugiere:",
  PARAM_ERROR_SUGGESTION_2: "Esto ocurre cuando algún esclavo no aceptó la parametrización realizada en el maestro o SDCD y no entró en intercambio de datos. La parametrización es una verificación del ID Number del esclavo, es decir, puede ser que se haya instalado un esclavo diferente al declarado en el sistema. Sugerencia:",
  PARAM_ERROR_SUGGESTION_3: "Verifique si el esclavo declarado en el software del maestro o SDCD es el mismo que está instalado en campo.",

  // ---------------------------- MISSING (TS EXPERT) ----------------------------
  MISSING_LIST_HEADER: "Existen dispositivos ausentes en la red.",
  DEVICE_MISSING: "Dispositivo ausente",

  MISSING_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía están ausentes:\n",
  S_MISSING_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía está ausente\n",

  MISSING_SUGGESTION_1: "Cuando un dispositivo esté ausente se sugiere:",
  MISSING_SUGGESTION_2: "Esto ocurre cuando el maestro o SDCD está buscando un esclavo en la red pero no recibe respuesta. Este esclavo fue configurado en el proyecto, pero no está respondiendo en la red o no está instalado. Sugerencia:",
  MISSING_SUGGESTION_3: "Verifique si el esclavo declarado en el software del maestro o SDCD está conectado a la red y alimentado.",
  MISSING_SUGGESTION_4: "No se recomienda dejar al maestro o SDCD buscando esclavos que no serán instalados.",

  // ---------------------------- ONLINE (TS EXPERT) ----------------------------
  ONLINE_LIST_HEADER: "Existen dispositivos online en la red.",
  DEVICE_ONLINE: "Dispositivo online",

  ONLINE_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía están online:\n",
  S_ONLINE_INITIAL_ERROR_MSG: "No fue posible verificar los eventos del dispositivo, pues todavía está online\n",

  ONLINE_SUGGESTION_1: "Cuando un dispositivo esté online se sugiere:",
  ONLINE_SUGGESTION_2: "Esto ocurre cuando el maestro o SDCD encuentra un esclavo en la red, pero no está configurado en el sistema. Sugerencia:",
  ONLINE_SUGGESTION_3: "Verifique si el esclavo debería estar fuera de la red o si debe ser configurado.",

  // ---------------------------- CRITICAL SLAVE (TS EXPERT) ----------------------------
  CRITICAL_SLAVE_LIST_HEADER: "Existen esclavos críticos en la red.",
  DEVICE_IS_CRITICAL_SLAVE: "El dispositivo es un esclavo crítico",

  CRITICAL_SLAVE_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues todavía son esclavos críticos:\n",
  S_CRITICAL_SLAVE_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues todavía es un esclavo crítico\n",

  CRITICAL_SLAVE_SUGGESTION_1: "Cuando existan esclavos críticos en la red se sugiere:",
  CRITICAL_SLAVE_SUGGESTION_2: "TS Monitor posee una función automática para seleccionar los esclavos que tengan un número excesivo de eventos e informar al usuario que este dispositivo es crítico para la red PROFIBUS. Sugerencia:",
  CRITICAL_SLAVE_SUGGESTION_3: "Verifique la condición de instalación del esclavo;",
  CRITICAL_SLAVE_SUGGESTION_4: "Verificar la alimentación del esclavo;",
  CRITICAL_SLAVE_SUGGESTION_5: "Verificar si está conectado a la red de forma correcta;",
  CRITICAL_SLAVE_SUGGESTION_6: "Verificar la integridad y el correcto montaje del conector;",
  CRITICAL_SLAVE_SUGGESTION_7: "Verificar la integridad del cable;",
  CRITICAL_SLAVE_SUGGESTION_8: "Verificar la calidad de la señal del esclavo con uno de los equipos de Toledo e Souza que posea osciloscopio;",
  CRITICAL_SLAVE_SUGGESTION_9: "Si el análisis con el equipo que posee osciloscopio no aporta la solución, se sugiere sustituir la interfaz de red.",
  CRITICAL_SLAVE_SUGGESTION_10: "Para retirar al esclavo de este estado es necesario entrar en configuraciones, luego en blacklist y desmarcar el checkbox.",

  // ---------------------------- MASTER FAULT (TS EXPERT) ----------------------------
  MASTER_FAULT_LIST_HEADER: "Existen maestros en falla en la red.",
  DEVICE_IS_MASTER_FAULT: "El dispositivo es un maestro en falla",

  MASTER_FAULT_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, pues no están recibiendo tramas PROFIBUS:\n",
  S_MASTER_FAULT_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, pues no está recibiendo tramas PROFIBUS\n",

  MASTER_FAULT_SUGGESTION_1: "Cuando existan maestros en falla en la red se sugiere:",
  MASTER_FAULT_SUGGESTION_2: "Esto ocurre cuando TS Monitor PROFIBUS deja de leer la red. Sugerencia:",
  MASTER_FAULT_SUGGESTION_3: "Verifique si hubo una falla general en la red;",
  MASTER_FAULT_SUGGESTION_4: "Verifique si TS Monitor fue aislado de la red;",
  MASTER_FAULT_SUGGESTION_5: "Verifique si TS Monitor está correctamente conectado a la red PROFIBUS.",

  VOLTAGE_: "Tensión",
  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG: "No fue posible confirmar los eventos porque el enlace de fibra óptica aún presenta una falla en el nivel de tensión.",
  S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG: "No fue posible confirmar el evento porque el enlace de fibra óptica aún presenta una falla en el nivel de tensión.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "Cuando se detecte un link de fibra óptica con falla en el nivel de tensión, se sugiere verificar visualmente:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "Se sugiere consultar el manual del fabricante del enlace de fibra para verificar el nivel de tensión adecuado.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG: "No fue posible confirmar los eventos porque el enlace de fibra óptica aún presenta una falla grave en el nivel de tensión.",
  S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG: "No fue posible confirmar el evento porque el enlace de fibra óptica aún presenta una falla grave en el nivel de tensión.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "Cuando se detecte un link de fibra óptica con una falla grave en el nivel de tensión, se sugiere verificar visualmente:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "Se sugiere consultar el manual del fabricante del enlace de fibra para verificar el nivel de tensión adecuado.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_ERROR_MSG: "No fue posible confirmar los eventos porque todavía se detecta una señal de falla por relé en el enlace de fibra óptica.",
  S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG: "No fue posible confirmar el evento porque todavía se detecta una señal de falla por relé en el enlace de fibra óptica.",

  FIBER_SIGNAL_LOSS_SUGGESTION_1: "Cuando se detecte una señal de falla por relé en el link de fibra óptica, se sugiere verificar visualmente:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Verificar la condición de las fibras ópticas.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_RETRIES_DOTS: "...........................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".......................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "...................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: ".......................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: "...................................................................................",
  DEVICE_MISSING_DOTS: "......................................................................................................................",
  DEVICE_ONLINE_DOTS: ".........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: ".............................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "..........................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "....................................................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "............................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "...............................................",
  FIBER_SIGNAL_LOSS_DOTS: "..................................................................................................",

  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Lista de acciones",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Link de fibra óptica – Falla en el nivel de tensión (Acción requerida)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Link de fibra óptica – Falla en el nivel de tensión (Acción urgente)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Link de fibra óptica – Falla por relé",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla en el nivel de tensión.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla en el nivel de tensión.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla por relé",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Fibra óptica",
  RELAY_STATUS: "Estado del relé",
  RELAY_SIGNAL: "Señal del relé",
  MIN: "Mínimo",
  MAX: "Máximo",
  FAULT: "Falla",
  OK: "OK",
  MIN_ANALOG_VALUE: "Valor mínimo analógico",
  MIN_LIMIT_NOT_VALID: "El valor mínimo analógico no es válido",
  STATUS: "Estado",
  MAINTENANCE_URGENT: "Valor de mantenimiento urgente",
  MAINTENANCE_REQUIRED: "Valor de mantenimiento requerido",
  DIVERGENCE_MAINTENANCE_VALUE: "¡El valor de mantenimiento requerido no puede ser menor que el de mantenimiento urgente!",
  INVALID_VALUE: "Valor inválido",
  STR_LIMIT: "Hasta",
  GOOD_STRING: "Bueno",
  ATTENTION_STRING: "Atención",
  BAD_STRING: "Malo",
  NO_SIGNAL_STRING: "Sin señal",
  UNKNOWN_STRING: "Desconocido",
  SIGNAL_QUALITY: "Calidad de la señal",
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",
  CHANNEL_5: "Canal 5",
  CHANNELS: "Canales",
  RELAY: "Relé",
  VOLTAGE: " V",
  ERROR_REASON: "\nMotivo: ",
  MONITORING: "Protocolo",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",
  GERMAN: "Alemán",
  UPDATING_LANGUAGE_WAITING: "Cambiando el idioma, espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",

  UPDATES_SUCCESS: "Actualizaciones realizadas con éxito",
  PS: "Nota:",
  PS_1: "Nota 1:",
  PS_2: "Nota 2:",
  PS_3: "Nota 3:",

  IP_ASSOCIATED_MONITOR: "Dirección IP del monitor asociado: ",
});

export default Constants;